import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class ScheduleLiveDemo extends Component {
  constructor(props) {
    super(props);
    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
  }

  componentDidMount() {}
  _HPEOnBackClick() {
    this.props.history.push("/");
  }

  render() {
    return (
      <Main fill="vertical" flex="grow" overflow="auto">
        <Box align="center" justify="center">
          <Heading>Schedule a demonstration</Heading>
          <Box
            align="center"
            justify="center"
            direction="column"
            pad="medium"
            gap="medium"
          >
            <Grid>
              <Text>Demo Type</Text>
              <Select options={["Customer demo", "Event", "Dry run"]} />
            </Grid>
            <Grid>
              <Text>Duration</Text>
              <Select options={["1h", "1.30h", "2h", "3h"]} />
            </Grid>
            <Grid>
              <Text>Where</Text>
              <Select options={["HPE site", "EBC", "Virtual"]} />
            </Grid>
            <Grid>
              <Text>Date / Start Time</Text>
              <DateInput format="mm/dd/yyyy" />
            </Grid>
          </Box>
          <Button label="NEXT" active={false} primary />
        </Box>
        <Box align="center" justify="center">
          <Heading>Schedule a demonstration</Heading>
          <Box
            align="center"
            justify="center"
            direction="column"
            pad="medium"
            gap="medium"
            border={{ style: "dashed" }}
          >
            <Grid>
              <Text>Customer details</Text>
              <TextInput />
            </Grid>
            <Box
              align="center"
              justify="center"
              direction="row"
              pad="small"
              gap="large"
              border={{ style: "dashed" }}
            >
              <Grid>
                <Grid>
                  <Text>OPP Id</Text>
                  <TextInput defaultValue="OPE-xxxxx" />
                </Grid>
              </Grid>
              <Button
                label="Validate OPP Id"
                icon={<Validate />}
                primary={false}
                secondary
              />
            </Box>
            <Box align="center" justify="center">
              <Grid fill="horizontal">
                <Text>Presenter's Email</Text>
                <TextInput
                  defaultValue="karim.wackdenheim@hpe.com"
                  size="medium"
                />
              </Grid>
            </Box>
          </Box>
          <Button label="Submit" active={false} primary reverse />
        </Box>
      </Main>
    );
  }
}

export default ScheduleLiveDemo;
